export default "__VITE_ASSET__abdda7a1__"